import { Component, OnInit, HostBinding, input } from "@angular/core";

@Component({
  selector: "av-card-row",
  templateUrl: "./card-row.component.html",
  styleUrls: ["./card-row.component.scss"],
  standalone: false,
})
export class CardRowComponent implements OnInit {
  readonly size = input<"md" | "sm" | "xs">("md");

  constructor() {}

  @HostBinding("class") get class() {
    return { ["av-card-row-size-" + this.size()]: true };
  }

  ngOnInit(): void {}
}
